import React, { useEffect, useMemo, useState, useRef, useCallback } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import "bootstrap/dist/css/bootstrap.min.css"
// import TableContainer from "../../components/Common/TableContainer"
import * as Yup from "yup"
import { useFormik } from "formik"

import * as imageConversion from "image-conversion"
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove"
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat"
import CloudUploadIcon from "@mui/icons-material/CloudUpload"
// import StockQtyDesing from "../../components/Common/StockQtyDesing"

import noimage from "../../assets/img/noimage.jpg"
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

//import components
// import Breadcrumbs from "../../components/Common/Breadcrumb"
import toastr from "toastr"
import "toastr/build/toastr.min.css";
// import {
//   getUsers as onGetUsers,
//   addNewUser as onAddNewUser,
//   updateUser as onUpdateUser,
//   deleteUser as onDeleteUser,
// } from "../../store/actions"
// import { GetProductinfodata } from "../../store/GetRecords/actions"
//redux
// import { useSelector, useDispatch } from "react-redux"
import axios from "../../axios"
import Select from "react-select"
import numeral from "numeral"
import AttachmentIcon from "@mui/icons-material/Attachment"
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  CardTitle,
  Table,
  Button,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { makeStyles } from "@material-ui/core/styles"
// import DeleteModal from "../../components/Common/DeleteModal"
import { Divider } from "@material-ui/core"
import { Button as CustomButton2, LinearProgress } from "@mui/material"
import { styled } from "@mui/system"
import SweetAlert from "react-bootstrap-sweetalert"
import Switch from "react-switch"
import { Dialog, DialogTitle } from "@material-ui/core"
import { Tooltip } from "@material-ui/core"
import Backdrop from "@material-ui/core/Backdrop"
import Spinner from "react-spinkit"
// import EditIcon from "@mui/icons-material/Edit"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  sticky: {
    position: "sticky",
    left: 0,
    background: "white",
    boxShadow: "5px 2px 5px grey",
    borderRight: "2px solid black"
  }
}))
// import "./Style.css"
// import UomMaster from "./UomMaster"
// import CategoryMaster from "./CategoryMaster"
// import Brandmaster from "./Brandmaster"



const CustomButton = styled(Button)({
  boxShadow: 0,
  marginLeft: 5,
  backgroundColor: "#3468C0",
  color: "#yourCustomTextColor",
  "&:hover": {
    backgroundColor: "#2c3e50",
  },
})



function DatatableTables() {
  const [openLoader, setOpenLoader] = useState(false)
  const [ShowUOMmaster, setShowUOMmaster] = useState(false)
  const [RandomCallbackUom, setRandomCallbackUom] = useState(false)
  const [modal, setModal] = useState(false)
  // const [modal1, setModal1] = useState(false);
  const [isEdit, setIsEdit] = useState(false)
  const classes = useStyles()
  const [userList, setUserList] = useState([])
  const [user, setUser] = useState([])
  const [duplicateerro, setduplicateerro] = useState(false)

  const [duplicateerro1, setduplicateerro1] = useState(false)
  const [coutrysuccess, setcoutrysuccess] = useState(false)
  const [countryerror, setcountryerror] = useState(false)
  const [countryinfo, setcountryinfo] = useState(false)
  const [deletid, setdeletid] = useState("")
  const [switch1, setswitch1] = useState(true)
  const [tokent, settokent] = useState(
    "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ"
  )
  const [RandomCallSeries, setRandomCallSeries] = useState('')
  const [ShowSeriesModal, setShowSeriesModal] = useState(false)
  const [allqaparameter, setallqaparameter] = useState([])
  const [allcategorycollections, setallcategorycollections] = useState([])
  const [allproductscollection, setallproductscollection] = useState([])
  const [categrid, setcategrid] = useState("")
  const [allpriuomcollection, setallpriuomcollection] = useState([])
  const [priuomid, setpriuomid] = useState("")
  const [allsecondaryuomcollection, setallsecondaryuomcollection] = useState([])
  const [secuomid, setsecuomid] = useState("")
  const [allseriescollections, setallseriescollections] = useState([])
  const [brandid, setbrandid] = useState("")
  const [alltaxcollections, setalltaxcollections] = useState([])
  const [taxid, settaxid] = useState("")
  const [hsncode, sethsncode] = useState("")
  const [categoryfilter, setcategoryfilter] = useState([])
  const categoryref = useRef("")
  const priuomref = useRef("")
  const secondaryuomref = useRef("")
  const brandref = useRef("")
  const vatref = useRef("")
  const [open, setopen] = useState(false)
  const [Page, setPage] = useState(1)
  const [pagePer, setpagePer] = useState(10)
  const [lastpage, setlastpage] = useState(0)
  const [categorydefaultvalue, setcategorydefaultvalue] = useState({
    label: "Select...",
    value: "",
  })
  const [CatShowModal, setCatShowModal] = useState(false)
  const [RandomCallBackCat, setRandomCallBackCat] = useState('')

  const [WarehouseTotalQty, setWarehouseTotalQty] = useState(0)
  const [ConQty, setConQty] = useState(1)
  const [WarehouseTotalQtySecondQty, setWarehouseTotalQtySecondQty] =
    useState(0)
  const [warehouseblockedSecondQty, setwarehouseblockedSecondQty] = useState(0)
  const [StockUOM, setStockUOM] = useState()
  const [UOMType, setUOMType] = useState("Secondary")
  const [SecondaryQtyUOM, setSecondaryQtyUOM] = useState("")
  const [warehouseBalanceQty, setwarehouseBalanceQty] = useState(0)
  const [warehouseblockedQty, setwarehouseblockedQty] = useState(0)
  const [PrimarywarehouseQty, setPrimarywarehouseQty] = useState(0)


  const [priuomdefaultvalue, setpriuomdefaultvalue] = useState({
    label: "Select...",
    value: "",
  })
  const [secondaryuomdefaultvalue, setsecondaryuomdefaultvalue] = useState({
    label: "Select...",
    value: "",
  })
  const [seriesdefaultvalue, setseriesdefaultvalue] = useState({
    label: "Select...",
    value: "",
  })
  const [AllBranddCollection, setAllBranddCollection] = useState([])
  const [BrandErr, setBrandErr] = useState(false)

  const [Brandlogo, setBrandlogo] = useState({ label: 'Select', value: '' })
  const [MOQ, setMOQ] = useState(0)
  const [vatpercentagedefaultvalue, setvatpercentagedefaultvalue] = useState({
    label: "Select...",
    value: "",
  })
  const [proid, setproid] = useState("")
  const [gsterror, setgsterror] = useState(false)
  const [categoryerror, setcategoryerror] = useState(false)
  const [secondaryuomerror, setsecondaryuomerror] = useState(false)
  const [priuomderror, setpriuomderror] = useState(false)
  const [buyerattcheload, setbuyerattcheload] = useState({ Imagepath: "" })
  const [buyerattchenamte, setbuyerattchenamte] = useState("")
  const [buyerattch, setbuyerattch] = useState(null)
  const [serieserror, setserieserror] = useState(false)
  const [Poupuimage, setPoupuimage] = useState("")
  const [dialogbox, setdialogbox] = useState(false)
  const [productvalue, setproductvalue] = useState("")
  const [ratecodevalue, setratecodevalue] = useState("")
  const [dailoa1, setdailoa1] = useState(false)


  const [taxiderr, settaxiderr] = useState(false)

  const [Servicetype, setServicetype] = useState(false)
  const [UomClickType, setUomClickType] = useState('')
  const [codeval, setcodeval] = useState("")
  const [allproductslists, setallproductslists] = useState({
    Product_Details_Description: "",
    Purchase_Rate: "",
    Sales_Rate: "",
    VAT_Percentage: "",
    ConQty: "",
    MRP_Rate: "",
    PHSNCode: "",
    Design: "",
    CGSTPer: "",
    SGSTPer: "",
    Active: "Y",
    ItemCode: "",
    SKUID: "",
    WarrantyYears: "",
    WarrantyMonths: "",
    Servicetype: "",
  })

  const [Active1, setActive1] = useState(true)

  const [deletedconfirm, setdeletedconfirm] = useState(false);

  // const dispatch = useDispatch()


  // useEffect(() => {
  //   dispatch(GetSUPPLIERdata())

  //   dispatch(GetCUSTOMERdata())

  //   dispatch(GetTaxinfodata())

  // }, [dispatch])

  // const BuyerAttchepack = async e => {
  //   var _URL = window.URL || window.webkitURL
  //   const file = e.target.files[0]
  //   var img = new Image()
  //   img.src = _URL.createObjectURL(file)
  //   img.onload = async () => {
  //     //  .. alert("width : "+img.width + " and height : " + img.height);
  //     if (img.width < img.height) {
  //       const imgfile = await imageConversion.compress(file, {
  //         quality: 0.5,
  //         type: file.type,
  //         width: 720,
  //         height: 1080,
  //       })
  //       setbuyerattcheload(imgfile)
  //       // await fetch('http://localhost:1000/Uploadimage', {method:'POST', body:formData})
  //     } else {
  //       const imgfile = await imageConversion.compress(file, {
  //         quality: 0.5,
  //         type: file.type,
  //         width: 1080,
  //         height: 720,
  //       })
  //       setbuyerattcheload(imgfile)
  //       // await fetch('http://localhost:1000/Uploadimage', {method:'POST', body:formData})
  //     }
  //   }

  //   //setbuyerattcheload(e.target.files[0])
  //   const filereader = new FileReader()
  //   filereader.readAsDataURL(e.target.files[0])
  //   filereader.onload = renderevent => {
  //     setbuyerattch(renderevent.target.result)

  //     setbuyerattchenamte(e.target.files[0].name)
  //   }
  // }

  // updated code 
  const BuyerAttchepack = async (e) => {
    if (!e || !e.target || !e.target.files || e.target.files.length === 0) {
      console.error("No file selected");
      return;
    }

    var _URL = window.URL || window.webkitURL;
    const file = e.target.files[0];

    if (!file) {
      console.error("File is undefined or null");
      return;
    }

    var img = new Image();
    img.src = _URL.createObjectURL(file);

    img.onload = async () => {
      let imgfile;

      if (img.width < img.height) {
        imgfile = await imageConversion.compress(file, {
          quality: 0.5,
          type: file.type,
          width: 720,
          height: 1080,
        });
      } else {
        imgfile = await imageConversion.compress(file, {
          quality: 0.5,
          type: file.type,
          width: 1080,
          height: 720,
        });
      }

      setbuyerattcheload(imgfile);
    };

    const filereader = new FileReader();
    filereader.readAsDataURL(file);

    filereader.onload = (renderevent) => {
      setbuyerattch(renderevent.target.result);
      setbuyerattchenamte(file.name);
    };
  };

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: allproductslists,

    validationSchema: Yup.object({
      Product_Details_Description: Yup.string()
        .max(100, " Product Description Must Be Atmost 100 Characters")
        .required("Please Enter Product Description"),
      // SKUID: Yup.string()
      //   .min(5, "SKU Id Must Be Atleast 5 Digits")
      //   .max(15, "SKU Id Must Be Atmost 15 Digits")
      //   .required("Please Enter SKU ID"),
      PHSNCode: Yup.string().max(15).required("Please Enter PHSNCode "),
      ConQty: Yup.string()
        .max(9, "Converstion Qty Must Be Atmost 9 Digits")
        .required("Please Enter Conversion Qty"),
      MRP_Rate: Yup.string().max(9, "MRP Rate Must Be Atmost 9 Digits"),
      // WarrantyYears: Yup.string().required("Please Enter Mould No"),
      // Purchase_Rate:Yup.string().max(9,'Purchase Rate Must Be Atmost 9 Digits').required('Please Enter Purchase Rate'),
      // Sales_Rate:Yup.string().max(9,'Sales Rate Must Be Atmost 9 Digits').required('Please Enter Sales Rate'),
      Design: Yup.string().max(50),
    }),
    onSubmit: async values => {

      // //console.log(values)
      if (isEdit) {
        // console.log(Brandlogo.value.length, Brandlogo.value)
        if (
          categorydefaultvalue.value != "" &&
          // brandid.length != 0 &&
          priuomid.length != 0 &&
          secuomid.length != 0 &&
          vatpercentagedefaultvalue.value.length != 0
          //  && Brandlogo.value != 0
        ) {

          setOpenLoader(true)
          let modifiedUrl
          let originalUrl = buyerattcheload
          const baseUrl = `${axios.baseURL+ 'ProductImages'}/`
          if (typeof originalUrl !== "object") {
            modifiedUrl = originalUrl.replace(baseUrl, "")
          } else {
            modifiedUrl = buyerattcheload
          }
          var n = values.Sales_Rate
          var digits = ("" + n).split("")

          let Value = ""
          for (let i = 0; i < digits.length; i++) {
            if (parseInt(digits[i]) === 0) {
              Value += "L"
            }
            if (parseInt(digits[i]) === 1) {
              Value += "K"
            }
            if (parseInt(digits[i]) === 2) {
              Value += "J"
            }
            if (parseInt(digits[i]) === 3) {
              Value += "I"
            }

            if (parseInt(digits[i]) === 4) {
              Value += "H"
            }
            if (parseInt(digits[i]) === 5) {
              Value += "G"
            }
            if (parseInt(digits[i]) === 6) {
              Value += "F"
            }

            if (parseInt(digits[i]) === 7) {
              Value += "E"
            }
            if (parseInt(digits[i]) === 8) {
              Value += "D"
            }
            if (parseInt(digits[i]) === 7) {
              Value += "C"
            }
          }
          const formdata = new FormData()
          formdata.append(
            "Product_Details_Description",
            values.Product_Details_Description
          )
          formdata.append("Product_Details_Code", 1)
          formdata.append("Category_Id", categrid)
          formdata.append("UOM_Id", priuomid)
          formdata.append("Tax_Id", 0)
          formdata.append("Purchase_Rate", values.Purchase_Rate)
          formdata.append("Sales_Rate", values.Sales_Rate)
          formdata.append("VAT_Percentage", vatpercentagedefaultvalue.value)
          formdata.append("Modify_By", sessionStorage.getItem("Userid"))
          formdata.append("Modify_Date", new Date())
          formdata.append("Active", switch1 ? "Y" : "N")
          formdata.append("ItemCode", values.ItemCode)
          // formdata.append("Brand_Id", brandid)
          formdata.append("ConQty", values.ConQty)
          formdata.append("Snd_UOM", secuomid)
          formdata.append("ProcessRate", 0)
          formdata.append("CGSTPer", values.CGSTPer)
          formdata.append("SGSTPer", values.SGSTPer)
          formdata.append("PHSNCode", values.PHSNCode)
          formdata.append("Margin", 0)
          formdata.append(
            "MRP_Rate", values.MRP_Rate === "" ? 0 : values.MRP_Rate
          )
          // formdata.append("SKU_Id", values.SKUID)
          // formdata.append("MOQ", MOQ)
          // formdata.append("BrandLogo_Id", Brandlogo.value)
          // formdata.append("Design_id", 0)
          // formdata.append("Design", values.Design)
          formdata.append("Imagepath", modifiedUrl)
          // formdata.append("RateCode", 0)
          formdata.append("Product_Details_Id", proid)
          formdata.append("WarrantyYears", values.WarrantyYears)
          formdata.append("WarrantyMonths", values.WarrantyMonths)
          formdata.append("Servicetype", Servicetype === true ? "Y" : "N")
          const update = await axios.instance
            .put(
              `/Updateproduct`,
              formdata,

              {
                headers: {
                  Authorization: tokent,
                  "Content-Type": "application/json",
                },
              }
            )
            .then(res => {
              // update user
              setActive1(true)
              if (res.data === "") {
                setdailoa1(true)
                Getallproduct1(Active1)

                toggle()
                setcountryinfo(true)
                setOpenLoader(false)
                setTimeout(() => {
                  setdailoa1(false)
                }, 1000)
                validation.resetForm()
              } else {
                // if (Brandlogo.value == "") {
                //   setBrandErr(true)
                // }

                setduplicateerro(true)
                setOpenLoader(false)
              }

            })
        } else {
          if (priuomid.length === 0) {
            setpriuomderror(true)
          }
          if (vatpercentagedefaultvalue.value.length === 0) {
            settaxiderr(true)
          }
          if (secuomid.length === 0) {
            setsecondaryuomerror(true)
          }
          // if (brandid.length === 0) {
          //   setserieserror(true)
          // }
          if (categorydefaultvalue.value === "") {
            setcategoryerror(true)
          }
          // if (Brandlogo.value == "0") {
          //   setBrandErr(true)
          // }

          setTimeout(() => {
            setcategoryerror(false)
            setserieserror(false)
            setBrandErr(false)
            setpriuomderror(false)
            setsecondaryuomerror(false)
            settaxiderr(false)
            //setgsterror(false)
          }, 5000)
        }
      } else {
        // //console.log(value)
        if (
          categorydefaultvalue.value != "" &&
          // brandid.length != 0 &&
          priuomid.length != 0 &&
          secuomid.length != 0 &&
          vatpercentagedefaultvalue.value.length != 0
          // && Brandlogo.value.length != 0
        ) {
          var n = values.Sales_Rate
          var digits = ("" + n).split("")

          let Value = ""
          for (let i = 0; i < digits.length; i++) {
            if (parseInt(digits[i]) === 0) {
              Value += "L"
            }
            if (parseInt(digits[i]) === 1) {
              Value += "K"
            }
            if (parseInt(digits[i]) === 2) {
              Value += "J"
            }
            if (parseInt(digits[i]) === 3) {
              Value += "I"
            }

            if (parseInt(digits[i]) === 4) {
              Value += "H"
            }
            if (parseInt(digits[i]) === 5) {
              Value += "G"
            }
            if (parseInt(digits[i]) === 6) {
              Value += "F"
            }

            if (parseInt(digits[i]) === 7) {
              Value += "E"
            }
            if (parseInt(digits[i]) === 8) {
              Value += "D"
            }
            if (parseInt(digits[i]) === 7) {
              Value += "C"
            }
            //setratecodevalue(Value)
          }
          const formdata = new FormData()
          formdata.append(
            "Product_Details_Description",
            values.Product_Details_Description
          )
          formdata.append("Product_Details_Code", 1)
          formdata.append("Category_Id", categrid)
          formdata.append("UOM_Id", priuomid)
          formdata.append("Tax_Id", 0)
          formdata.append(
            "Purchase_Rate",
            values.Purchase_Rate === "" ? 0 : values.Purchase_Rate
          )
          formdata.append(
            "Sales_Rate",
            values.Sales_Rate === "" ? 0 : values.Sales_Rate
          )
          formdata.append(
            "VAT_Percentage",
            vatpercentagedefaultvalue.value === ""
              ? 0
              : vatpercentagedefaultvalue.value
          )
          formdata.append("Created_By", sessionStorage.getItem("Userid"))
          formdata.append("Created_Date", new Date())
          formdata.append("Active", switch1 ? "Y" : "N")
          formdata.append("ItemCode", values.ItemCode)
          formdata.append("Brand_Id", brandid)
          formdata.append("ConQty", values.ConQty)
          formdata.append("Snd_UOM", secuomid)
          formdata.append("ProcessRate", 0)
          formdata.append("CGSTPer", values.CGSTPer === "" ? 0 : values.CGSTPer)
          formdata.append("SGSTPer", values.SGSTPer === "" ? 0 : values.SGSTPer)
          formdata.append("PHSNCode", values.PHSNCode)
          formdata.append("Margin", 0)
          formdata.append(
            "MRP_Rate",
            values.MRP_Rate === "" ? 0 : values.MRP_Rate
          )
          formdata.append("SKU_Id", values.SKUID)
          formdata.append("MOQ", MOQ)
          formdata.append("BrandLogo_Id", Brandlogo.value)
          // formdata.append("Design_id", 0)
          // formdata.append("Design", values.Design)
          formdata.append("WarrantyYears", values.WarrantyYears)
          formdata.append("WarrantyMonths", values.WarrantyMonths)
          formdata.append("Servicetype", Servicetype === true ? "Y" : "N")
          formdata.append("Imagepath", buyerattcheload)
          // --formdata.append('ProductLogo', '')
          formdata.append("RateCode", Value)

          const createoneuser = await axios.instance
            .post(
              "/Insertproduct",
              formdata, //{
              // Product_Details_Description:values.Product_Details_Description,
              // Product_Details_Code:1,
              // Category_Id:categrid,
              // UOM_Id:priuomid,
              // Tax_Id:0,
              // Purchase_Rate:values.Purchase_Rate,
              // Sales_Rate:values.Sales_Rate,
              // VAT_Percentage:taxid,
              // Created_By:sessionStorage.getItem('Userid'),
              // Created_Date:new Date(),
              // Active:switch1 ? 'Y' : 'N',
              // ItemCode:1,
              // Brand_Id:brandid,
              // ConQty:values.ConQty,
              // Snd_UOM:secuomid,
              // ProcessRate:0,
              // CGSTPer:values.CGSTPer,
              // SGSTPer:values.SGSTPer,
              // PHSNCode:values.PHSNCode,
              // Margin:0,
              // // ProductLogo:"",
              // MRP_Rate:values.MRP_Rate,
              // Design_id:0,
              // Design:values.Design,
              // Imagepath:"",
              // RateCode:0
              //}
              {
                headers: {
                  Authorization: tokent,
                  "Content-Type": "application/json",
                },
              }
            )
            .then(async res => {
              if (res.data.length === 1) {
                setdailoa1(true)
                for (const data of res.data) {
                  var sliceno = data.Product_Details_Id.toString().length
                  var str1 = "8600000000001"
                  var slicenos = parseInt(sliceno)
                  var str2 = str1.slice(0, -slicenos) + data.Product_Details_Id
                  const updateitemcode = await axios.instance.put(
                    "/Updateproductbarcode",
                    {
                      ItemCode: str2,
                      Product_Details_Id: data.Product_Details_Id,
                    },
                    {
                      headers: {
                        Authorization: tokent,
                        "Content-Type": "application/json",
                      },
                    }
                  )
                }

                setcoutrysuccess(true)
                Getallproduct1(Active1)

                setOpenLoader(false)
                setTimeout(() => {
                  setdailoa1(false)
                }, 1000)
                validation.resetForm()
                toggle()
              } else {
                setduplicateerro(true)
                setOpenLoader(false)
              }
              //toastr.success('Garment Description Added Successfully', 'Garment')
            })
        } else {
          //  if(taxid.length === 0) {
          //    setgsterror(true)
          //  }
          // if(categorydefaultvalue.value===''){
          //   setcategoryerror(true)
          // }

          if (priuomid.length === 0) {
            setpriuomderror(true)
          }
          if (vatpercentagedefaultvalue.value.length === 0) {
            settaxiderr(true)
          }
          if (secuomid.length === 0) {
            setsecondaryuomerror(true)
          }
          // if (brandid.length === 0) {
          //   setserieserror(true)
          // }
          if (categorydefaultvalue.value === "") {
            setcategoryerror(true)
          }
          // if (Brandlogo.value == "") {
          //   setBrandErr(true)
          // }

          setTimeout(() => {
            setcategoryerror(false)
            setserieserror(false)
            // setBrandErr(false)
            setpriuomderror(false)
            setsecondaryuomerror(false)
            settaxiderr(false)
            //setgsterror(false)
          }, 2000)
        }
      }

      setDeleteModal(false)
    },
  })
  const CallbackfromMaster = (value, value1) => {
    //console.log(value,value1,'     //console.log(value,value1)')
    if (value) {

      if (value1 == 'Pri' || value1 == 'PriAdd') {
        setpriuomdefaultvalue({ label: "Select...", value: "" })
        Getallpriuom()
        Getallsecondaryuom()
        setpriuomid('')
        setUomClickType('')
      } else if (value1 == 'Sec' || value1 == 'SecAdd') {
        setsecondaryuomdefaultvalue({ label: "Select...", value: "" })
        Getallsecondaryuom()
        Getallpriuom()
        setsecuomid('')
        setUomClickType('')

      }
      else {
        setUomClickType('')
      }
    }
  }
  const CallbackfromMasterCat = (value, value1) => {
    //console.log(value,value1,'     //console.log(value,value1)')
    if (value) {
      Getallcategory()
      setcategorydefaultvalue({
        label: "Select...",
        value: "",
      })
      setcategrid('')


    }
  }
  const CallbackfromMasterSeries = (value) => {
    //console.log(value,'CallbackfromMasterSeries')
    if (value) {
      setseriesdefaultvalue({ label: "Select...", value: "" })
      setbrandid('')
      GetallSeries()
      Getallbrand()



    }
  }

  const GetBlockedStock = async (id) => {
    try {
      const get = await axios.instance
        .get(
          `/Getoneproductforbockandstock/${id}/${sessionStorage.getItem(
            "CompanyId"
          )}/${sessionStorage.getItem(
            "BranchID")}`,
          {
            headers: {
              Authorization: tokent,
              "Content-Type": "application/json",
            },
          }
        )
        .then(async res => {
          //console.log(res.data, "Getoneproductforbockandstock")

          if (res.data.length != 0) {
            // setViewStockDetails(res.data.length > 0)
            for (const data of res.data) {

              setwarehouseblockedQty(data.block)
              setwarehouseblockedSecondQty(data.Secondaryblock)
              setWarehouseTotalQty(data.stock)
              setConQty(data.ConQty)
              setWarehouseTotalQtySecondQty(data.SecondaryStock)
              setStockUOM(data.UOM_Description)
              setUOMType("Secondary")
              setSecondaryQtyUOM(data.SecondaryUOM)



            }
          }

        })
    } catch (error) {
      // setViewStockDetails(false)

      setwarehouseblockedQty(0)
      setwarehouseblockedSecondQty(0)
      setWarehouseTotalQty(0)
      setWarehouseTotalQtySecondQty(0)
      setStockUOM(0)
      setUOMType("Secondary")
      setSecondaryQtyUOM(0)
    }
  }
  // const toggleViewModal = () => setModal1(!modal1);
  const Getallcategory = async () => {
    const get = await axios.instance
      .get("/Getallcategory", {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.Category_Description,
          value: b.Category_Id,
        }))
        options.unshift({ label: "Add Category....", value: "" })
        setallcategorycollections(options)

        setcategoryfilter(res.data)
      })
  }

  const GetallSeries = async () => {
    const get = await axios.instance
      .get(`/GetallBrand/${"Y"}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.Brand,
          value: b.Brand_Id,
        }))
        // options.unshift({ label: "Add Series....", value: "" })
        setallseriescollections(options)
      })
  }
  const Getallbrand = async () => {
    const get = await axios.instance
      .get(`/GetallBrandlogo/${"Y"}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.Brand,
          value: b.Brand_Id,
        }))
        // options.unshift({ label: "Add Series....", value: "" })
        setAllBranddCollection(options)
      })
  }


  const Getalltax = async () => {
    const get = await axios.instance
      .get("/Getalltaxper", {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.Tax_Percentage,
          value: b.Tax_Percentage,
        }))

        setalltaxcollections(options)
      })
  }

  const Getallpriuom = async () => {
    const get = await axios.instance
      .get("/GetallUom", {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.UOM_Description,
          value: b.UOM_Id,
        }))
        options.unshift({ label: "Add UOM....", value: "" })
        setallpriuomcollection(options)
      })
  }

  const Getallsecondaryuom = async () => {
    const get = await axios.instance
      .get("/GetallUom", {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.UOM_Description,
          value: b.UOM_Id,
        }))
        options.unshift({ label: "Add UOM....", value: "" })
        setallsecondaryuomcollection(options)
      })
  }

  const toggle = () => {
    if (modal) {
      setModal(false)
      setIsEdit(false)
      setswitch1(true)
      setServicetype(false)
      setpriuomid('')
      setsecuomid('')
      setcategrid('')
      setbrandid('')
      setcategorydefaultvalue({ label: "Select...", value: "" })
      setpriuomdefaultvalue({ label: "Select...", value: "" })
      setsecondaryuomdefaultvalue({ label: "Select...", value: "" })
      setvatpercentagedefaultvalue({ label: "Select...", value: "" })
      setseriesdefaultvalue({ label: "Select...", value: "" })
      setBrandlogo({ label: "Select...", value: "" })

      setMOQ(0)
      setbuyerattcheload({ Imagepath: "" })
      setbuyerattchenamte("")
      setbuyerattch(null)
      setUser(null)
      setcodeval("")
      validation.resetForm()
      setallproductslists({
        Product_Details_Description: "",
        Product_Details_Code: "",
        Category_Id: "",
        UOM_Id: "",
        Tax_Id: "",
        Purchase_Rate: "",
        Sales_Rate: "",
        VAT_Percentage: "",
        Openning_Balance: "",
        Purchase_Qty: "",
        Sales_Qty: "",
        Qty_On_Hand: "",
        Created_By: "",
        Created_Date: "",

        ItemCode: "",
        SKUID: "",
        Brand_Id: "",
        CheckBoxSerialNo: "",
        WarrantyYears: "",
        WarrantyMonths: "",
        CheckGNL: "",
        ConQty: "",
        Snd_UOM: "",
        ProcessRate: "",
        CGSTPer: "",
        SGSTPer: "",
        PHSNCode: "",
        Margin: "",

        MRP_Rate: "",
        Design_id: "",
        Design: "",
        Imagepath: "",
        Active: "Y",
        RateCode: "",
      })
    } else {
      setModal(true)
      setServicetype(false)
    }
  }

  const handleUserClick = async arg => {
    console.log(arg)
    const qapara = arg
    setproid(qapara.Product_Details_Id)
    GetBlockedStock(qapara.Product_Details_Id)
    if (qapara.Active === "Y") {
      setswitch1(true)
    } else {
      setswitch1(false)
    }
    setallproductslists({
      Product_Details_Description: qapara.Product_Details_Description,
      Purchase_Rate: qapara.Purchase_Rate,
      Sales_Rate: qapara.Sales_Rate,

      ConQty: qapara.ConQty,
      PHSNCode: qapara.PHSNCode,
      MRP_Rate: qapara.MRP_Rate,
      Design: qapara.Design,
      Product_Details_Id: qapara.Product_Details_Id,
      CGSTPer: qapara.CGSTPer,
      SGSTPer: qapara.SGSTPer,
      ItemCode: qapara.ItemCode,
      WarrantyYears: qapara.WarrantyYears,
      SKUID: qapara.SKU_Id,
      WarrantyMonths: qapara.WarrantyMonths,
      Servicetype: qapara.Servicetype,
    })
    setpriuomid(qapara.UOM_Id)
    setsecuomid(qapara.Snd_UOM)
    settaxid(qapara.VAT_Percentage)
    setcategrid(qapara.Category_Id)
    setbrandid(qapara.Brand_Id)
    setMOQ(qapara.MOQ)
    setBrandlogo({
      label: qapara.BrandLogo,
      value: qapara.Brand_IdLogo,
    })
    setbuyerattcheload(`${axios.baseURL+'ProductImages/'}/${qapara.Imagepath}`)
    setcodeval(qapara.Product_Details_Code)
    setServicetype(qapara.Servicetype === "Y" ? true : false)
    setvatpercentagedefaultvalue({
      label: qapara.VAT_Percentage,
      value: qapara.VAT_Percentage,
    })



    setcategorydefaultvalue({
      label: qapara.Category_Description,
      value: qapara.Category_Id,
    })
    setsecondaryuomdefaultvalue({
      label: qapara.SecondaryUOM,
      value: qapara.Snd_UOM,
    })
    setpriuomdefaultvalue({
      label: qapara.PrimaryUOM,
      value: qapara.UOM_Id,
    })
    setseriesdefaultvalue({ label: qapara.Brand, value: qapara.Brand_Id })

    // if (sessionStorage.getItem === "R") {
    //   const deleteoneuser = await axios.instance
    //     .get(`/Getonecategory/${qapara.Category_Id}`, {
    //       headers: {
    //         Authorization: tokent,
    //         "Content-Type": "application/json",
    //       },
    //     })
    //     .then(res => {
    //       for (const data of res.data) {
    //         setcategorydefaultvalue({
    //           label: data.Category_Description,
    //           value: data.Category_Id,
    //         })
    //       }
    //     })
    // } else {
    //   const deleteoneuser = await axios.instance
    //     .get(`/Getonecategory1/${qapara.Category_Id}`, {
    //       headers: {
    //         Authorization: tokent,
    //         "Content-Type": "application/json",
    //       },
    //     })
    //     .then(res => {
    //       for (const data of res.data) {
    //         setcategorydefaultvalue({
    //           label: data.Category_Description,
    //           value: data.Category_Id,
    //         })
    //       }
    //     })
    // }

    // const getonesecuom = await axios.instance
    //   .get(`/Getoneuom/${qapara.Snd_UOM}`, {
    //     headers: { Authorization: tokent, "Content-Type": "application/json" },
    //   })
    //   .then(res => {
    //     for (const data of res.data) {
    //       setsecondaryuomdefaultvalue({
    //         label: data.UOM_Description,
    //         value: data.UOM_Id,
    //       })
    //     }

    // Categoryref.current.select.commonProps.setValue({
    //   label:defects.CategoryDescription,
    //   value:defects.CategoryId
    // })
    // const getpriuomid = await axios.instance
    //   .get(`/Getoneuom/${qapara.UOM_Id}`, {
    //     headers: { Authorization: tokent, "Content-Type": "application/json" },
    //   })
    //   .then(res => {
    //     for (const data of res.data) {
    //       setpriuomdefaultvalue({
    //         label: data.UOM_Description,
    //         value: data.UOM_Id,
    //       })
    //     }

    //     // Categoryref.current.select.commonProps.setValue({
    //     //   label:defects.CategoryDescription,
    //     //   value:defects.CategoryId
    //   })
    // const getonebrand = await axios.instance
    //   .get(`/Getonebrand/${qapara.Brand_Id}`, {
    //     headers: { Authorization: tokent, "Content-Type": "application/json" },
    //   })
    //   .then(res => {
    //     for (const data of res.data) {
    //       setseriesdefaultvalue({ label: data.Brand, value: data.Brand_Id })
    //     }

    //     // Categoryref.current.select.commonProps.setValue({
    //     //   label:defects.CategoryDescription,
    //     //   value:defects.CategoryId
    //   })

    // set({label:defects.Buyer,value:defects.BuyerId})

    setIsEdit(true)

    toggle()
  }

  const gotoPage = async (Active, pageno, pageper) => {

    const get = await axios.instance
      .get(`GetProductInfo/${Active === true ? "Y" : "N"}/?page=${pageno}&limit=${pageper}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        console.log(data)
        if (data.result.length > 0) {
          setPage(pageno)
          setallproductscollection(res.data.result)
        } else {
          setActive1(true)
          setnoRecords(true)
        }
      })
  }


  const productdatasearch = async (Active, pageno, pageper, value) => {

    const get = await axios.instance
      .get(`GetProductsearch/${Active === true ? 'Y' : 'N'}/?page=${pageno}&limit=${pageper}&search=${value}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data

        if (data.result.length > 0) {
          setPage(pageno)
          setallproductscollection(res.data.result)
        } else {
          setallproductscollection([])
        }
      })
  }

  //delete user
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = user => {
    setdeletid(user.Product_Details_Id)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (user.id) {
      // dispatch(onDeleteUser(user))
      setDeleteModal(false)
    }
  }

  const handleUserClicks = () => {
    setUserList("")
    setIsEdit(false)
    toggle()
  }

  useEffect(() => {
    //console.log(sessionStorage.getItem("HidePurchaseRate") === 'Y')
    Getallproduct1(Active1)
    Getallcategory()
    Getallpriuom()
    Getallsecondaryuom()
    GetallSeries()
    Getallbrand()
    Getalltax()
  }, [])

  const Countrydelete = async () => {
    const deleteoneuser = await axios.instance
      .delete(`/deleteproduct/${deletid}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        if (res.data === "") {
          Getallproduct1(Active1)

          setDeleteModal(false)
          setcountryerror(true)
          setActive1(true)
        } else {
          toastr.error("Already Used Cannot be Deleted", "Product")
          setDeleteModal(false)
        }
      })
  }

  const [noRecords, setnoRecords] = useState(false)

  useEffect(() => {
    Getallproduct1(Active1)
  }, [Active1])

  // const Getallproduct = async () => {
  //   const get = await axios.instance
  //     .get(`/Getallproducts/${"Y"}`, {
  //       headers: { Authorization: tokent, "Content-Type": "application/json" },
  //     })
  //     .then(res => {
  //       setallproductscollection(res.data)
  //     })
  // }

  const Getallproduct1 = async id => {
    const get = await axios.instance
      .get(`GetProductInfo/${id === true ? "Y" : "N"}/?page=${Page}&limit=${pagePer}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data

        if (data.result.length > 0) {
          setallproductscollection(res.data.result)
          setlastpage(data.lastpage.lastpage)
          // dispatch(GetProductinfodata())
        } else {
          setActive1(true)
          setnoRecords(true)
        }
      })
  }

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        No
      </div>
    )
  }

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Yes
      </div>
    )
  }

  const getcateid = id => {
    setcategrid(id)
    const data = categoryfilter.filter(id1 => id1.Category_Id == id)
    // //console.log(data)
    for (const data2 of data) {
      //sethsncode(data2.CHSNCode)
      //console.log(data2.VAT_Percentage)
      validation.values.PHSNCode =
        data2.ApplicableForAll == "Y" ? data2.CHSNCode : ""
      validation.values.CGSTPer = data2.VAT_Percentage / 2
      validation.values.SGSTPer = data2.VAT_Percentage / 2
      setvatpercentagedefaultvalue({
        label: data2.VAT_Percentage,
        value: data2.VAT_Percentage,
      })
    }
  }

  const getpriuomid = id => {

    setUomClickType('Pri')
    setpriuomid(id)
    if (secuomid === id) {
      validation.values.ConQty = 1
    } else {
      validation.values.ConQty = ""
    }
  }
  const getseconduomid = id => {
    setUomClickType('Sec')
    setsecuomid(id)
    if (priuomid === id) {
      validation.values.ConQty = 1
    } else {
      validation.values.ConQty = ""
    }
  }
  const gettaxid = id => {
    //console.log(id)
    settaxid(id)

    validation.values.SGSTPer = id / 2
    validation.values.CGSTPer = id / 2
  }
  const brandids = id => {
    setbrandid(id)
  }

  function debugBase64(base64URL) {
    //var win = window.open();
    //win.document.write('<iframe src="' + base64URL  + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
    setPoupuimage(base64URL)
    setopen(true)
  }
  const Closepopup = () => {
    setopen(false)
  }

  let columns = []

  if (sessionStorage.getItem("WebCal") === "R") {
    columns = useMemo(
      () => [
        {
          Header: "Product Description",
          accessor: "Product_Details_Description",
          disableFilters: true,
          filterable: true,
        },

        {
          Header: "Category",
          accessor: "Category_Description",
          disableFilters: true,
          filterable: true,
        },
        {
          Header: "Brand",
          accessor: "Brand",
          disableFilters: true,
          filterable: true,
        },
        {
          Header: "Design",
          accessor: "Design",
          disableFilters: true,
          filterable: true,
        },
        {
          Header: "Primary UOM",
          accessor: "PrimaryUOM",
          disableFilters: true,
          filterable: true,
        },
        {
          Header: "Secondary UOM",
          accessor: "SecondaryUOM",
          disableFilters: true,
          filterable: true,
        },
        {
          Header: "Conversion Qty",
          accessor: "ConQty",
          disableFilters: true,
          filterable: true,
        },

        {
          Header: "GST %",
          accessor: "VAT_Percentage",
          disableFilters: true,
          filterable: true,
        },

        {
          Header: "Brand",
          accessor: "Brand",
          filterable: false,
          disableFilters: true,
        },

        {
          Header: "MRP",
          accessor: cellProps => (
            <React.Fragment>
              {numeral(cellProps.MRP_Rate).format("0,0.00")}
            </React.Fragment>
          ),
          filterable: false,
          disableFilters: true,
        },
        {
          Header: "Purchase Price",
          accessor: cellProps => (
            <React.Fragment>
              {numeral(cellProps.Purchase_Rate).format("0,0.00")}
            </React.Fragment>
          ),
          filterable: false,
          disableFilters: true,
        },

        {
          Header: "Sales Prices",
          accessor: cellProps => (
            <React.Fragment>
              {numeral(cellProps.Sales_Rate).format("0,0.00")}
            </React.Fragment>
          ),
          filterable: false,
          disableFilters: true,
        },
        {
          Header: "Design",
          accessor: "Design",
          filterable: false,
          disableFilters: true,
        },

        {
          Header: "Photo ",
          // accessor: "name",
          filterable: false,
          disableFilters: true,

          accessor: cellProps => (
            <React.Fragment>
              <div className="d-flex justify-content-center align-items-center gap-2 w-100">
                {cellProps.Imagepath != "" ? (
                  <img
                    src={`${axios.baseURL + 'ProductImages'}/${cellProps.Imagepath}`}
                    width="50px"
                    height="50px"
                    onClick={() => debugBase64(cellProps.Imagepath)}
                    style={{ objectFit: "contain" }}
                  />
                ) : (
                  <img
                    src={noimage}
                    width="50px"
                    height="50px"
                    onClick={() => debugBase64(noimage)}
                    style={{ objectFit: "contain" }}
                  />
                )}
              </div>
            </React.Fragment>
          ),
        },

        {
          Header: "Action",
          accessor: "action",
          disableFilters: true,
          Cell: cellProps => {
            return (
              <div className="d-flex justify-content-center align-items-center gap-2">
                {/* edit icon */}
                <Tooltip title="Edit" placement="left-start">
                  <Link
                    to="#"
                    className="text-primary"
                    onClick={() => {
                      const users = cellProps.row.original
                      handleUserClick(users)
                    }}
                  >
                    <i
                      className="uil uil-pen font-size-18"
                      id="edittooltip"
                      style={{ color: "blue" }}
                    />
                  </Link>
                </Tooltip>

                {/* delete icon */}
                <Tooltip title="Delete" placement="right-end">
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => {
                      if (
                        JSON.parse(
                          sessionStorage.getItem("MenuItemProductDetailControls")
                        ).Del == "Y"
                      ) {
                        const users = cellProps.row.original
                        onClickDelete(users)
                      } else {
                        toastr.warning(
                          "Please Contact Admin",
                          "Operation Not Allowed"
                        )
                      }
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                  </Link>
                </Tooltip>
              </div>
            )
          },
        },
      ],
      []
    )
  } else {
    columns = useMemo(
      () => [
        {
          Header: "Mould No",
          accessor: "WarrantyYears",
          disableFilters: true,
          filterable: true,
        },
        {
          Header: "SKU Id",
          accessor: "SKU_Id",
          disableFilters: true,
          filterable: true,
        },
        {
          Header: "Product Description",
          accessor: "Product_Details_Description",
          disableFilters: true,
          filterable: true,
        },

        {
          Header: "Category",
          accessor: "Category_Description",
          disableFilters: true,
          filterable: true,
        },
        {
          Header: "Specs",
          accessor: "Design",
          disableFilters: true,
          filterable: true,
        },
        {
          Header: "Primary UOM",
          accessor: "PrimaryUOM",
          disableFilters: true,
          filterable: true,
        },
        {
          Header: "Secondary UOM",
          accessor: "SecondaryUOM",
          disableFilters: true,
          filterable: true,
        },
        {
          Header: "Conversion Qty",
          accessor: "ConQty",
          disableFilters: true,
          filterable: true,
        },
        {
          Header: "MOQ",
          accessor: "MOQ",
          disableFilters: true,
          filterable: true,
        },

        {
          Header: "GST %",
          accessor: "VAT_Percentage",
          disableFilters: true,
          filterable: true,
        },

        {
          Header: "Series",
          accessor: "Brand",
          filterable: false,
          disableFilters: true,
        },
        {
          Header: "Brand",
          accessor: "BrandLogos",
          filterable: false,
          disableFilters: true,
        },


        {
          Header: "MRP",
          accessor: cellProps => (
            <React.Fragment>
              {numeral(cellProps.MRP_Rate).format("0,0.00")}
            </React.Fragment>
          ),
          filterable: false,
          disableFilters: true,
        },
        {
          Header: "Purchase Price",
          accessor: cellProps => (
            <React.Fragment>
              {numeral(cellProps.Purchase_Rate).format("0,0.00")}
            </React.Fragment>
          ),
          filterable: false,
          disableFilters: true,
        },

        {
          Header: "Sales Price",
          accessor: cellProps => (
            <React.Fragment>
              {numeral(cellProps.Sales_Rate).format("0,0.00")}
            </React.Fragment>
          ),
          filterable: false,
          disableFilters: true,
        },
        {
          Header: "Photo ",
          // accessor: "name",
          filterable: false,
          disableFilters: true,

          accessor: cellProps => (
            <React.Fragment>
              <Link to="#" className="text-body">
                {cellProps.Imagepath != "" ? (
                  <img
                    src={`${axios.baseURL + 'ProductImages'}/${cellProps.Imagepath}`}
                    width="50px"
                    height="50px"
                    style={{ objectFit: "contain" }}
                    onClick={() => {
                      debugBase64(`${axios.baseURL + 'ProductImages'}/${cellProps.Imagepath}`)
                      // productpreview(noimage)
                    }}
                  />
                ) : (
                  <img
                    src={noimage}
                    width="50px"
                    height="50px"
                    style={{ objectFit: "contain" }}
                    onClick={() => {
                      debugBase64(noimage)
                      // productpreview(noimage)
                    }}
                  />
                )}
              </Link>
            </React.Fragment>
          ),
        },

        {
          Header: "Action",
          accessor: "action",
          disableFilters: true,
          Cell: cellProps => {
            return (
              <div className="d-flex justify-content-center align-items-center gap-2">
                {/* edit icon */}
                <Tooltip title="Edit" placement="left-start">
                  <Link
                    to="#"
                    className="text-primary"
                    onClick={() => {
                      const users = cellProps.row.original
                      handleUserClick(users)
                    }}
                  >
                    <i
                      className="uil uil-pen font-size-18"
                      id="edittooltip"
                      style={{ color: "blue" }}
                    />
                  </Link>
                </Tooltip>

                {/* delete icon */}
                <Tooltip title="Delete" placement="right-end">
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => {
                      if (
                        JSON.parse(
                          sessionStorage.getItem("MenuItemProductDetailControls")
                        ).Del == "Y"
                      ) {
                        const users = cellProps.row.original
                        onClickDelete(users)
                      } else {
                        toastr.warning(
                          "Please Contact Admin",
                          "Operation Not Allowed"
                        )
                      }
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                  </Link>
                </Tooltip>
              </div>
            )
          },
        },
      ],
      []
    )
  }


  //console.log()
  return (
    <React.Fragment>
      {/* <DeleteModal
        show={deleteModal}
        onDeleteClick={Countrydelete}
        onCloseClick={() => setDeleteModal(false)}
      /> */}
      <div className="page-content" style={{ backgroundColor: "inherit" }}>
        <div className="">
          <Row>

            <Col xs="12">
              <h6 className="titleviewinspections">Product Master</h6>
              <Card>
                <CardBody>
                  <div>
                    {/* <Breadcrumbs
                      title="Master"
                      breadcrumbItem="Product Master"
                    /> */}
                  </div>
                  <Divider sx={{ mb: 2 }} />

                  <div className="d-flex justify-content-end align-items-center mt-3">
                    <Col
                      xl={12}
                      className="d-flex justify-content-end gap-2 align-items-center"
                    >

                      <div
                        className="d-flex d-flex-column gap-2 justify-content-between  pr-2"
                        style={{
                          borderRight: "1px solid #61677A",
                          paddingRight: "10px",
                        }}
                      >

                        <h5 className="font-size-14 mt-1">Active Products</h5>
                        <div className="mt-2 ml-2">
                          <Switch
                            onChange={checked => {
                              {
                                checked ? setActive1(true) : setActive1(false)
                              }
                              Getallproduct1(checked)
                            }}
                            checked={Active1}
                            width={40}
                            height={20}
                          />
                        </div>
                      </div>
                      <CustomButton
                        variant="contained"
                        onClick={() => {
                          // if (
                          //   JSON.parse(
                          //     sessionStorage.getItem(
                          //       "MenuItemProductDetailControls"
                          //     )
                          //   ).New == "Y"
                          // ) {
                          toggle()

                          // } else {
                          //   toastr.warning(
                          //     "Please Contact Admin",
                          //     "Operation Not Allowed"
                          //   )
                          // }
                        }}
                        size="small"
                      >
                        Add Product
                      </CustomButton>
                    </Col>
                  </div>

                  {/* <TableContainer
                    columns={columns.filter((data) => (sessionStorage.getItem("InventoryAccess") === 'N' ? true : data.Header  !='MRP') && (sessionStorage.getItem("HidePurchaseRate") === 'N' ? true: data.Header !='Purchase Price') && (sessionStorage.getItem("HideSalesRate") === 'N' ? true: data.Header !='Sales Price'))}
                    data={allproductscollection}
                    isGlobalFilter={true}
                    // isAddUsers={true}
                    isAddTableWithoutBorderStrap={true}
                    hand
                    
                    leUserClicks={handleUserClicks}
                  /> */}
                  {/* <Col sm={4}>
                    <div className="search-box me-2 mb-2 d-inline-block mt-1">
                      <div className="position-relative">
                        <label htmlFor="search-bar-0" className="search-label">
                          <span id="search-bar-0-label" className="sr-only">
                            Search this table
                          </span>
                          <input

                            id="search-bar-0"
                            type="text"
                            className="form-control"
                            placeholder={`${lastpage * 10} records...`}
                            //value={value || ""}
                            onChange={(e) => {
                              //   let ProductArray =  OpeningStockQuantitydata3.filter(item => {
                              //     return Productsearch.some(key => 

                              //          item[key].toString().toLowerCase().includes(e.target.value.toLowerCase().trim())
                              //      )
                              //     })
                              //   setOpeningStockQuantitydata2(ProductArray)
                              //   setOpeningStockQuantitydata(ProductArray)
                              setTimeout(() => {
                                productdatasearch(Active1, Page, pagePer, e.target.value)
                                console.log(Active1, Page, pagePer, e.target.value, "Yuk")
                              }, 300);

                            }}



                          />
                        </label>
                        <i className="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </Col> */}


                  <div style={{ marginBottom: "25px" }}
                  // className="table-container"
                  >
                    <Table
                      bordered
                      hover
                      responsive
                      style={{

                        border: "1px solid white",
                        fontSize: "13px",
                      }}
                    >
                      <thead style={{ border: "1px solid white" }} >
                        <tr
                          style={{
                            padding: "3px",
                            backgroundColor: "#2D9596",
                            border: "1px solid white",
                          }}
                        >
                          {/* <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                          }}
                          rowSpan={2}
                          className="text-center"
                        >
                         Mould No
                        </th> */}
                          {/* <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                            maxWidth: "30px",
                          }}
                          rowSpan={2}
                          className="text-center"
                        >
                          SKU Id
                        </th> */}
                          <th
                            style={{
                              padding: "3px",
                              backgroundColor: "#3876BF",
                              color: "white",
                              whiteSpace: "nowrap",

                            }}

                            className="text-center"
                          >
                            Product Description
                          </th>
                          <th
                            style={{
                              padding: "3px",
                              backgroundColor: "#3876BF",
                              color: "white",
                              maxWidth: "30px",
                            }}

                            className="text-center"
                          >
                            Category
                          </th>
                          {/* <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                            maxWidth: "30px",
                          }}
                          rowSpan={2}
                          className="text-center"
                        >
                        Specs
                        </th> */}
                          {/* <th
                            style={{
                              padding: "3px",
                              backgroundColor: "#3876BF",
                              color: "white",
                              maxWidth: "100px",
                            }}
                            rowSpan={2}
                            className="text-center"
                          >
                            Net Rate
                          </th> */}
                          <th
                            style={{
                              padding: "3px",
                              backgroundColor: "#3876BF",
                              color: "white",
                              maxWidth: "100px",
                            }}
                            rowSpan={2}
                            className="text-center"
                          >
                            UOM Description
                          </th>

                          {/* <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                            minWidth: "70px",
                          }}
                          className="text-center"
                        >
                          Secondary UOM
                        </th> */}
                          {/* <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                            minWidth: "80px",
                          }}
                          className="text-center"
                        >
                          Conversion Qty
                        </th> */}
                          {/* <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                            minWidth: "70px",
                          }}
                          className="text-center"
                        >
                        MOQ
                        </th> */}
                          <th
                            style={{
                              padding: "3px",
                              backgroundColor: "#3876BF",
                              color: "white",
                              minWidth: "70px",
                            }}
                            className="text-center"
                          >
                            Tax Percentage
                          </th>
                          {/* <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                            minWidth: "100px",
                          }}
                          rowSpan={2}
                          className="text-center"
                        >
                          Series
                        </th> */}


                          {/* <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                            minWidth: "100px",
                          }}
                          rowSpan={2}
                          className="text-center"
                        >
                          Brand
                        </th> */}
                          {/* {sessionStorage.getItem("InventoryAccess") === 'N' &&
                        <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                          }}
                          rowSpan={2}
                          className="text-center"
                        >
                          MRP
                        </th>
} */}
                          {/* {sessionStorage.getItem("HidePurchaseRate") === 'N' &&
                        <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                          }}
                          rowSpan={2}
                          className="text-center"
                        >
                          Purchase Price
                        </th>
} */}
                          {/* {sessionStorage.getItem("HideSalesRate") === 'N' &&
                        <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                          }}
                          rowSpan={2}
                          className="text-center"
                        >
                          Sales Price
                        </th>
} */}
                          <th style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                          }}
                            // rowSpan={2}
                            className="no-scroll">
                            <th
                              style={{
                                // padding: "3px", 
                                // marginLeft:10
                                // backgroundColor: "#3876BF",
                                // color: "white",
                              }}
                              // rowSpan={2}
                              className=" table text-center "
                            >
                              Photo
                            </th>
                            {/* <th
                              style={{
                                // padding: "3px", 
                                // marginLeft:10
                                // backgroundColor: "#3876BF",
                                // color: "white",
                              }}
                              // rowSpan={2}
                              className="text-center "
                            >
                              Action
                            </th> */}
                          </th>
                          <th
                            style={{
                              padding: "3px",
                              backgroundColor: "#3876BF",
                              color: "white",
                            }}
                            rowSpan={2}
                            className="text-center"
                          >
                            Edit
                          </th>
                          <th
                            style={{
                              padding: "3px",
                              backgroundColor: "#3876BF",
                              color: "white",
                            }}
                            rowSpan={2}
                            className="text-center"
                          >
                            Delete
                          </th>

                        </tr>
                      </thead>

                      <tbody
                        style={{
                          border: "1px solid rgb(169 169 169 / 14%)",
                          backgroundColor: "white",
                        }}
                      >
                        {allproductscollection.map((data, index) => (


                          <tr key={index} style={{ backgroundColor: "white" }} >
                            {/* <td style={{ backgroundColor: "white" }}  >
                              {data.WarrantyYears}
                            </td> */}
                            {/* <td style={{ backgroundColor: "white" }} >
                              {data.SKU_Id}
                            </td> */}
                            <td style={{ backgroundColor: "white" }} >
                              {data.Product_Details_Description}
                            </td>
                            <td style={{ backgroundColor: "white" }} >
                              {data.Category_Description}
                            </td>
                            {/* <td style={{ backgroundColor: "white" }} >
                              {data.Design}
                            </td> */}
                            <td style={{ backgroundColor: "white" }} >
                              {data.PrimaryUOM}
                            </td>
                            {/* <td style={{ backgroundColor: "white" }} >
                              {data.SecondaryUOM}
                            </td> */}
                            {/* <td style={{ backgroundColor: "white" }} >
                            
                              {data.ConQty}
                            </td> */}
                            {/* <td style={{ backgroundColor: "white" }} >
                            {data.MOQ}
                            </td> */}
                            <td style={{ backgroundColor: "white" }} >
                              {data.VAT_Percentage}
                            </td>
                            {/* <td style={{ backgroundColor: "white" }} >
                              {data.Brand}
                            </td> */}
                            {/* <td style={{ backgroundColor: "white" }} >
                              {data.BrandLogos}
                            </td> */}
                            {/* {sessionStorage.getItem("HidePurchaseRate") === 'N' &&
                            <td style={{ backgroundColor: "white" }} >
                            {numeral(data.MRP_Rate).format("0,0.00")}
                            </td>
                            } */}
                            {/* {(sessionStorage.getItem("HideSalesRate") === 'N' &&
                            <td style={{ backgroundColor: "white" }} >
                            {numeral(data.Purchase_Rate).format("0,0.00")}
                            </td>
                            )} */}
                            {/* {(sessionStorage.getItem("HideSalesRate") === 'N' &&
                            <td style={{ backgroundColor: "white" }} >
                            {numeral(data.Sales_Rate).format("0,0.00")}
                            </td>
                                   )} */}
                            <td style={{ backgroundColor: "white" }} className="no-scrolls">
                              <td style={{ backgroundColor: "white" }} className="no-scrolls">
                                <div className="d-flex justify-content-center align-items-center no-scrolls gap-2">
                                  <Link to="#" >
                                    {data.Imagepath != "" ? (
                                      <img
                                        src={`${axios.baseURL + 'ProductImages/'+data.Imagepath}`}
                                        width="50px"
                                        height="50px"
                                        style={{ objectFit: "contain" }}
                                        onClick={() => {
                                          debugBase64(
                                            // `${axios.baseURL}/${data.Imagepath}`
                                        
                                            // productpreview(noimage)
                                            `${axios.baseURL + 'ProductImages/'+data.Imagepath}`                                             
                                          )
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={noimage}
                                        width="50px"
                                        height="50px"
                                        style={{ objectFit: "contain" }}
                                        onClick={() => {
                                          debugBase64(noimage)
                                          // productpreview(noimage)
                                        }}
                                      />
                                    )}
                                  </Link>
                                </div>
                              </td>
                              {/* <td className="no-scroll">
                                <div className="d-flex justify-content-center align-items-center no-scroll gap-2">
                                

                                  <Tooltip title="Edit" placement="left-start">
                                    <Link
                                      to="#"
                                      className="text-primary"
                                      onClick={() => {
                                        const users = data
                                        handleUserClick(users)
                                      }}
                                    >
                                      <i
                                        className="uil uil-pen font-size-18"
                                        id="edittooltip"
                                        style={{ color: "blue" }}
                                      />
                                    </Link>
                                  </Tooltip>

                                 
                                  <Tooltip title="Delete" placement="right-end">
                                    <Link
                                      to="#"
                                      className="text-danger"
                                      onClick={() => {
                                        if (
                                          JSON.parse(
                                            sessionStorage.getItem("MenuItemProductDetailControls")
                                          ).Del == "Y"
                                        ) {
                                          const users = data
                                          onClickDelete(users)
                                        } else {
                                          toastr.warning(
                                            "Please Contact Admin",
                                            "Operation Not Allowed"
                                          )
                                        }
                                      }}
                                    >
                                      <i
                                        className="uil uil-trash-alt font-size-18"
                                        id="deletetooltip"
                                      />
                                    </Link>
                                  </Tooltip>
                                </div>
                              </td> */}
                            </td>
                            <td style={{ backgroundColor: "white" }}>
                              {/* <TableCell align="left"> */}
                              <IconButton size="small">
                                <EditIcon
                                  fontSize="small"
                                  color="primary"
                                  onClick={() => {
                                    console.log(data);
                                    handleUserClick(data);
                                  }}
                                />
                              </IconButton>
                              {/* </TableCell> */}
                            </td>
                            <td>
                              {/* <TableCell align="left"> */}
                              <IconButton size="small">
                                <DeleteIcon
                                  color="error"
                                  fontSize="small"
                                  onClick={() => {
                                    setdeletedconfirm(true);
                                    setdeletid(data.Product_Details_Id);
                                  }}
                                />
                              </IconButton>
                              {/* </TableCell> */}
                            </td>

                          </tr>
                        ))}
                      </tbody>
                    </Table>

                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center">
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          color="primary"
                          onClick={() => gotoPage(Active1, 1, pagePer)}
                          disabled={Page === 1}
                        >
                          {"<<"}
                        </Button>
                        <Button
                          color="primary"
                          // onClick={previousPage}
                          // disabled={!canPreviousPage}
                          onClick={() => gotoPage(Active1, Page - 1, pagePer)}
                          disabled={Page === 1}
                        >
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Page{" "}
                      <strong>
                        {Page} of {lastpage}
                      </strong>
                    </Col>
                    <Col className="col-md-auto">
                      <Input
                        disabled
                        type="number"
                        min={1}
                        value={Page}
                        style={{ width: 70 }}

                      // max={pageOptions.length}
                      // defaultValue={pageIndex + 1}
                      // onChange={onChangeInInput}
                      />
                    </Col>

                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="primary"
                          disabled={Page === lastpage}
                          //  onClick={nextPage} disabled={!canNextPage}
                          onClick={() => gotoPage(Active1, Page + 1, pagePer)}
                        >
                          {">"}
                        </Button>
                        <Button
                          color="primary"
                          onClick={() => gotoPage(Active1, lastpage, pagePer)}
                          // disabled={!canNextPage}
                          disabled={Page === lastpage}
                        >
                          {">>"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </CardBody>

              </Card>
            </Col>

          </Row>
          <Modal isOpen={modal} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit Product Detail" : "Add Product Detail"}
            </ModalHeader>
            <ModalBody>
              {/* <Row className='mb-3'> {isEdit&& 
              <StockQtyDesing  
                  Uom={StockUOM}
                  SecUom={SecondaryQtyUOM}
                  Stock={WarehouseTotalQty}
                  SecStock={WarehouseTotalQtySecondQty}
                  Blocked={warehouseblockedQty}
                  SecBlocked={warehouseblockedSecondQty} 
                  ProductId={proid}
                  ConQty={ConQty}
                  WarehouseId={0}
                  />}</Row> */}
              <Row>

                {/* <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">Code</Label>
                    <Input
                      autoComplete="off"
                      type="number"
                      name="code"
                      className="form-control"
                      id="basicpill-lastname-input2"
                      disabled={true}
                      value={codeval}
                      onChange={e => {
                        setcodeval(e.target.value)
                      }}
                    />
                  </div>
                </Col> */}
                {/* warehouseyears column used for Mould No*/}
                {/* <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">
                      Mould No
                      <span style={{ color: "red" }}>*</span>
                    </Label>
                    <Input
                      autoComplete="off"
                      type="number"
                      name="WarrantyYears"
                      className="form-control"
                      id="basicpill-lastname-input2"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.WarrantyYears || ""}
                      invalid={
                        validation.touched.WarrantyYears &&
                          validation.errors.WarrantyYears
                          ? true
                          : false
                      }
                    />
                    {validation.touched.WarrantyYears &&
                      validation.errors.WarrantyYears ? (
                      <FormFeedback type="invalid">
                        {validation.errors.WarrantyYears}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col> */}
                <Col lg="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Description <b className="text-danger">*</b>{" "}
                    </Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="Product_Details_Description"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={
                        validation.values.Product_Details_Description || ""
                      }
                      invalid={
                        validation.touched.Product_Details_Description &&
                          validation.errors.Product_Details_Description
                          ? true
                          : false
                      }
                    />
                    {validation.touched.Product_Details_Description &&
                      validation.errors.Product_Details_Description ? (
                      <FormFeedback type="invalid">
                        {validation.errors.Product_Details_Description}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col>

                <Col lg="3">
                  <div className="mb-3">
                    <Label htmlFor="manufacturerbrand">
                      <b>
                        Category <b className="text-danger">*</b>
                      </b>
                      {/* {categrid.length == 0 ? (
                        <IconButton
                          aria-label="add"
                          color="success"
                          size={"small"}
                          onClick={() => {


                            setCatShowModal(true)
                            setRandomCallBackCat((Math.floor(Math.random() * 90) + 10))
                          }}
                        >
                          <AddCircleOutlineIcon sx={{ fontSize: "15px" }} />
                        </IconButton>
                      ) : (
                        <IconButton
                          aria-label="add"
                          color="warning"
                          size={"small"}
                          onClick={() => {
                            setCatShowModal(true)
                            setRandomCallBackCat((Math.floor(Math.random() * 90) + 10))
                          }}
                        >
                          <EditIcon sx={{ fontSize: "15px" }} />
                        </IconButton>
                      )} */}
                    </Label>
                    <Select
                      name="CategoryId"
                      options={allcategorycollections}
                      ref={categoryref}
                      classNamePrefix="select2-search-disable"
                      value={categorydefaultvalue}
                      onChange={value => {
                        if (value.label == "Add Category....") {
                          setCatShowModal(true)
                          setRandomCallBackCat((Math.floor(Math.random() * 90) + 10))
                        } else {
                          getcateid(value.value)
                          setcategorydefaultvalue({
                            label: value.label,
                            value: value.value,
                          })
                        }

                      }}
                    //  defaultValue={categorydefaultvalue}
                    />
                    {categoryerror ? (
                      <p style={{ fontSize: "12px" }} className="error">
                        Please Select Category{" "}
                      </p>
                    ) : null}
                  </div>
                </Col>
                <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">
                      HSN/SAC Code <b className="text-danger">*</b>
                    </Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      name="PHSNCode"
                      className="form-control"
                      id="basicpill-lastname-input2"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.PHSNCode || ""}
                      invalid={
                        validation.touched.PHSNCode &&
                          validation.errors.PHSNCode
                          ? true
                          : false
                      }
                    />
                    {validation.touched.PHSNCode &&
                      validation.errors.PHSNCode ? (
                      <FormFeedback type="invalid">
                        {validation.errors.PHSNCode}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col>
              </Row>
              <Row>
                {/* <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">
                      <b>SKU ID</b>
                      <span style={{ color: "red" }}>*</span>
                    </Label>
                    <Input
                      autoComplete="off"
                      type="number"
                      name="SKUID"
                      className="form-control"
                      id="basicpill-lastname-input2"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.SKUID || ""}
                      invalid={
                        validation.touched.SKUID && validation.errors.SKUID
                          ? true
                          : false
                      }
                      max={15}
                    />
                    {validation.touched.SKUID && validation.errors.SKUID ? (
                      <FormFeedback type="invalid">
                        {validation.errors.SKUID}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col> */}
                <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">
                      Primary UOM <b className="text-danger">*</b>
                      {/* {priuomid.length == 0 ? (
                        <IconButton
                          aria-label="add"
                          color="success"
                          size={"small"}
                          onClick={() => {
                            setUomClickType('PriAdd')
                            setShowUOMmaster(true)
                            setRandomCallbackUom((Math.floor(Math.random() * 90) + 10))
                          }}
                        >
                          <AddCircleOutlineIcon sx={{ fontSize: "15px" }} />
                        </IconButton>
                      ) : (
                        <IconButton
                          aria-label="add"
                          color="warning"
                          size={"small"}
                          onClick={() => {
                            setUomClickType('Pri')
                            setShowUOMmaster(true)
                            setRandomCallbackUom((Math.floor(Math.random() * 90) + 10))
                          }}
                        >
                          <EditIcon sx={{ fontSize: "15px" }} />
                        </IconButton>
                      )} */}
                    </Label>
                    <Select
                      name="CategoryId"
                      options={allpriuomcollection}
                      // ref={priuomref}
                      classNamePrefix="select2-search-disable"
                      onChange={value => {
                        if (value.label == "Add UOM....") {
                          setUomClickType('PriAdd')
                          setShowUOMmaster(true)
                          setRandomCallbackUom((Math.floor(Math.random() * 90) + 10))

                        } else {
                          getpriuomid(value.value)
                          setpriuomdefaultvalue(value)
                        }


                      }}
                      value={priuomdefaultvalue}
                    />
                    {priuomderror ? (
                      <p style={{ fontSize: "12px" }} className="error">
                        Please Select Primary UOM{" "}
                      </p>
                    ) : null}
                  </div>
                </Col>
                <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">
                      Secondary UOM <b className="text-danger">*</b>
                      {/* {secuomid.length == 0 ? (
                        <IconButton
                          aria-label="add"
                          color="success"
                          size={"small"}
                          onClick={() => {
                            setUomClickType('SecAdd')
                            setShowUOMmaster(true)
                            setRandomCallbackUom((Math.floor(Math.random() * 90) + 10))
                          }}
                        >
                          <AddCircleOutlineIcon sx={{ fontSize: "15px" }} />
                        </IconButton>
                      ) : (
                        <IconButton
                          aria-label="add"
                          color="warning"
                          size={"small"}
                          onClick={() => {
                            setUomClickType('Sec')
                            setShowUOMmaster(true)
                            setRandomCallbackUom((Math.floor(Math.random() * 90) + 10))
                          }}
                        >
                          <EditIcon sx={{ fontSize: "15px" }} />
                        </IconButton>
                      )} */}
                    </Label>
                    <Select
                      name="CategoryId"
                      options={allsecondaryuomcollection}
                      // ref={secondaryuomref}
                      classNamePrefix="select2-search-disable"
                      onChange={value => {
                        if (value.label == "Add UOM....") {
                          setUomClickType('SecAdd')
                          setShowUOMmaster(true)
                          setRandomCallbackUom((Math.floor(Math.random() * 90) + 10))

                        } else {
                          getseconduomid(value.value)
                          setsecondaryuomdefaultvalue(value)
                        }
                      }}
                      value={secondaryuomdefaultvalue}
                    />
                    {secondaryuomerror ? (
                      <p style={{ fontSize: "12px" }} className="error">
                        Please Select Secondary UOM{" "}
                      </p>
                    ) : null}
                  </div>
                </Col>
                <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">
                      Conversion Qty
                    </Label>

                    <Input
                      autoComplete="off"
                      type="number"
                      name="ConQty"
                      className="form-control"
                      id="basicpill-lastname-input2"
                      disabled={secuomid === priuomid}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.ConQty || ""}
                      invalid={
                        validation.touched.ConQty && validation.errors.ConQty
                          ? true
                          : false
                      }
                    />
                    {validation.touched.ConQty && validation.errors.ConQty ? (
                      <FormFeedback type="invalid">
                        {validation.errors.ConQty}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col>
                {/* <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">Item Code</Label>
                    <Input
                      autoComplete="off"
                      type="number"
                      name="ItemCode"
                      className="form-control"
                      id="basicpill-lastname-input2"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.ItemCode || ""}
                      invalid={
                        validation.touched.ItemCode &&
                        validation.errors.ItemCode
                          ? true
                          : false
                      }
                    />
                  </div>
                </Col> */}


                {sessionStorage.getItem("InventoryAccess") === 'N' &&
                  <Col lg="3">
                    <div className="mb-3">
                      <Label for="basicpill-lastname-input2">MRP</Label>
                      <Input
                        autoComplete="off"
                        type="number"
                        name="MRP_Rate"
                        className="form-control"
                        id="basicpill-lastname-input2"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.MRP_Rate || ""}
                        invalid={
                          validation.touched.MRP_Rate &&
                            validation.errors.MRP_Rate
                            ? true
                            : false
                        }
                      />
                    </div>
                  </Col>
                }
                {sessionStorage.getItem("HidePurchaseRate") === 'N' &&
                  <Col lg="3">
                    <div className="mb-3">
                      <Label for="basicpill-lastname-input2">
                        Purchase Price
                      </Label>
                      <Input
                        autoComplete="off"
                        type="number"
                        name="Purchase_Rate"
                        className="form-control"
                        id="basicpill-lastname-input2"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.Purchase_Rate || ""}
                        invalid={
                          validation.touched.Purchase_Rate &&
                            validation.errors.Purchase_Rate
                            ? true
                            : false
                        }
                      />
                      {validation.touched.Purchase_Rate &&
                        validation.errors.Purchase_Rate ? (
                        <FormFeedback type="invalid">
                          {validation.errors.Purchase_Rate}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                }
                {sessionStorage.getItem("HideSalesRate") === 'N' &&
                  <Col lg="3">
                    <div className="mb-3">
                      <Label for="basicpill-lastname-input2">Sales Price</Label>
                      <Input
                        autoComplete="off"
                        type="number"
                        name="Sales_Rate"
                        className="form-control"
                        id="basicpill-lastname-input2"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.Sales_Rate || ""}
                        invalid={
                          validation.touched.Sales_Rate &&
                            validation.errors.Sales_Rate
                            ? true
                            : false
                        }
                      />
                      {validation.touched.Sales_Rate &&
                        validation.errors.Sales_Rate ? (
                        <FormFeedback type="invalid">
                          {validation.errors.Sales_Rate}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                }
                <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">
                      GST% <b className="text-danger">*</b>
                    </Label>
                    <Select
                      name="CategoryId"
                      options={alltaxcollections}
                      // ref={Categoryref}
                      value={vatpercentagedefaultvalue}
                      classNamePrefix="select2-search-disable"
                      onChange={value => {
                        gettaxid(value.value)
                        setvatpercentagedefaultvalue(value)
                      }}
                    // defaultValue={vatpercentagedefaultvalue}
                    />
                    {taxiderr ? (
                      <p style={{ fontSize: "12px" }} className="error">
                        Please Select GST%{" "}
                      </p>
                    ) : null}
                  </div>
                </Col>

                <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">CGST%</Label>
                    <Input
                      autoComplete="off"
                      type="number"
                      name="CGSTPer"
                      className="form-control"
                      id="basicpill-lastname-input2"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.CGSTPer || ""}
                      disabled
                      invalid={
                        validation.touched.CGSTPer && validation.errors.CGSTPer
                          ? true
                          : false
                      }
                    />
                    {validation.touched.CGSTPer && validation.errors.CGSTPer ? (
                      <FormFeedback type="invalid">
                        {validation.errors.CGSTPer}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col>

                <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">SGST%</Label>
                    <Input
                      autoComplete="off"
                      type="number"
                      name="SGSTPer"
                      className="form-control"
                      id="basicpill-lastname-input2"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.SGSTPer || ""}
                      disabled
                      invalid={
                        validation.touched.SGSTPer && validation.errors.SGSTPer
                          ? true
                          : false
                      }
                    />
                    {validation.touched.SGSTPer && validation.errors.SGSTPer ? (
                      <FormFeedback type="invalid">
                        {validation.errors.SGSTPer}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col>
                {/* <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">Specs</Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      name="Design"
                      className="form-control"
                      id="basicpill-lastname-input2"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.Design || ""}
                      invalid={
                        validation.touched.Design && validation.errors.Design
                          ? true
                          : false
                      }
                    />
                    {validation.touched.Design && validation.errors.Design ? (
                      <FormFeedback type="invalid">
                        {validation.errors.Design}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col> */}
                {/* <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">Series                     
                    </Label>


                    <Select
                      name="Brand"
                      options={allseriescollections}
                      classNamePrefix="select2-search-disable"
                      value={seriesdefaultvalue}
                      onChange={value => {

                        if (value.label == "Add Series....") {
                          //console.log('first')
                          setShowSeriesModal(true)
                          setRandomCallSeries((Math.floor(Math.random() * 90) + 10))
                        } else {
                          setseriesdefaultvalue(value)
                          brandids(value.value)
                        }
                      }}

                    />
                    {serieserror ? (
                      <p style={{ fontSize: "12px" }} className="error">
                        Please Select Series{" "}
                      </p>
                    ) : null}
                  </div>
                </Col> */}

                <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">Brand

                    </Label>


                    <Select
                      name="Brand"
                      options={AllBranddCollection}
                      classNamePrefix="select2-search-disable"
                      value={Brandlogo}
                      onChange={value => {


                        setBrandlogo(value)


                      }}

                    />
                    {BrandErr ? (
                      <p style={{ fontSize: "12px" }} className="error">
                        Please Select Brand{" "}
                      </p>
                    ) : null}
                  </div>
                </Col>

                {/* <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">MOQ
                    </Label>
                    <Input
                      name="MOQ"
                      type="number"
                      classNamePrefix="select2-search-disable"
                      value={MOQ}

                      onChange={e => {
                        setMOQ(e.target.value)
                      }}

                    />

                  </div>
                </Col> */}


                <Col xl={3}>
                  <p className="font-size-14 mb-3">Service Type</p>
                  <div className="mt-2">
                    <Switch
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#626ed4"
                      onChange={checked => {
                        {
                          checked ? setServicetype(true) : setServicetype(false)
                        }
                      }}
                      checked={Servicetype}
                    />
                  </div>
                </Col>
                <Col xl={3}>
                  <h5 className="font-size-14 mb-3">Active</h5>
                  {isEdit ? (
                    <div className="mt-2">
                      {
                        (allproductslists.Active = "Y" ? (
                          <Switch
                            uncheckedIcon={<Offsymbol />}
                            checkedIcon={<OnSymbol />}
                            onColor="#626ed4"
                            onChange={() => {
                              setswitch1(!switch1)
                            }}
                            checked={switch1}
                          />
                        ) : (
                          <Switch
                            uncheckedIcon={<Offsymbol />}
                            checkedIcon={<OnSymbol />}
                            onColor="#626ed4"
                            onChange={() => {
                              setswitch1(switch1)
                            }}
                            checked={!switch1}
                          />
                        ))
                      }
                    </div>
                  ) : (
                    <div className="mt-2">
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        onColor="#626ed4"
                        onChange={() => {
                          setswitch1(!switch1)
                        }}
                        checked={switch1}
                      />
                    </div>
                  )}
                </Col>
                <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-address-input1 pl-2 ">
                      Product Image
                    </Label>
                    <div
                      onClick={() =>
                        document.getElementById("productimage").click()
                      }
                      className="d-flex justify-content-center align-items-center "
                    >
                      <CustomButton2
                        variant="outlined"
                        color="primary"
                        startIcon={<CloudUploadIcon />}
                        size="small"
                        sx={{ textTransform: "capitalize" }}
                        fullWidth
                      >
                        Choose Image
                      </CustomButton2>
                      <Input
                        id="productimage"
                        name="price"
                        type="file"
                        accept="image/*"
                        onChange={BuyerAttchepack}
                        className="form-control"
                        hidden
                      />
                    </div>
                  </div>
                </Col>
                <Col className="mt-2">
                  {isEdit ? (
                    <>
                      {typeof buyerattcheload === "string" ? (
                        <>
                          {buyerattcheload && (
                            <div className="d-flex justify-content-start align-items-center gap-2">
                              <TrendingFlatIcon color="info" sx={{ mr: 2 }} />
                              <img
                                src={buyerattcheload}
                                width="100px"
                                height="70px"
                                style={{ objectFit: "contain", border: 0 }}
                                className="imagePreview"
                              />
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          {buyerattch && (
                            <div className="d-flex justify-content-start align-items-center gap-2">
                              <TrendingFlatIcon color="info" sx={{ mr: 2 }} />
                              <img
                                src={buyerattch}
                                width="100px"
                                height="70px"
                                className="imagePreview"
                                style={{ objectFit: "contain", border: 0 }}
                              />
                            </div>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {typeof buyerattcheload === "string" ? (
                        <>
                          {buyerattcheload && (
                            <div className="d-flex justify-content-start align-items-center gap-2">
                              <TrendingFlatIcon color="info" sx={{ mr: 2 }} />
                              <img
                                src={axios.baseURL + 'ProductImages' + buyerattcheload}
                                width="100px"
                                height="70px"
                                style={{ objectFit: "contain", border: 0 }}
                                className="imagePreview"
                              />
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          {buyerattch && (
                            <div className="d-flex justify-content-start align-items-center gap-2">
                              <TrendingFlatIcon color="info" sx={{ mr: 2 }} />
                              <img
                                src={buyerattch}
                                width="100px"
                                height="70px"
                                style={{ objectFit: "contain", border: 0 }}
                                className="imagePreview"
                              />
                            </div>
                          )}
                        </>
                      )}
                    </>
                  )}
                </Col>
              </Row>
              <Row>
                <Col lg="12">
                  <div className="d-flex justify-content-end">
                    {!!isEdit ? (
                      <button
                        type="submit"
                        style={{
                          backgroundColor: "#1746A2",
                          color: "white",
                          border: 0,
                        }}
                        className="btn btn-primary save-user"
                        onClick={e => {
                          console.log("clicked")
                          e.preventDefault();
                          if (priuomid.length === 0) {
                            setpriuomderror(true);
                          }
                          if (vatpercentagedefaultvalue.value.length === 0) {
                            settaxiderr(true);
                          }
                          if (secuomid.length === 0) {
                            setsecondaryuomerror(true);
                          }
                          if (categorydefaultvalue.value === "") {
                            setcategoryerror(true);
                          }
                          // if (Brandlogo.value == "") {
                          //   setBrandErr(true);
                          // }
                          setTimeout(() => {
                            setcategoryerror(false);
                            setserieserror(false);
                            setBrandErr(false);
                            setpriuomderror(false);
                            setsecondaryuomerror(false);
                            settaxiderr(false);
                          }, 2000);
                          // if (
                          //   allproductscollection.filter(
                          //     data =>
                          //       // Number(data.SKU_Id) === Number(validation.values.SKUID) &&
                          //       Number(data.Product_Details_Id) !== Number(proid)
                          //   ).length !== 0
                          // ) {
                          //   // if (validation.values.SKUID.length !== 0) {
                          //   //   setduplicateerro1(true);
                          //   // }
                          // } else {
                            validation.handleSubmit();
                          // }
                          return false;
                        }}
                      >
                        Update
                      </button>
                    ) : (
                      <button
                        type="submit"
                        style={{
                          backgroundColor: "#1746A2",
                          color: "white",
                          border: 0,
                        }}
                        className="btn btn-success save-user"
                        onClick={e => {
                          e.preventDefault();
                          if (priuomid.length === 0) {
                            setpriuomderror(true);
                          }
                          if (vatpercentagedefaultvalue.value.length === 0) {
                            settaxiderr(true);
                          }
                          if (secuomid.length === 0) {
                            setsecondaryuomerror(true);
                          }
                          if (categorydefaultvalue.value === "") {
                            setcategoryerror(true);
                          }
                          // if (Brandlogo.value == "") {
                          //   setBrandErr(true);
                          // }
                          setTimeout(() => {
                            setcategoryerror(false);
                            setserieserror(false);
                            setBrandErr(false);
                            setpriuomderror(false);
                            setsecondaryuomerror(false);
                            settaxiderr(false);
                          }, 2000);
                          // if (
                          //   allproductscollection.filter(
                          //     // data => Number(data.SKU_Id) === Number(validation.values.SKUID)
                          //   ).length !== 0
                          // ) {
                          //   if (validation.values.SKUID.length !== 0) {
                          //     setduplicateerro1(true);
                          //   }
                          // } else {
                            validation.handleSubmit();
                          // }
                          // return false;
                        // }
                      }
                      }
                      >
                        Add
                      </button>
                    )}
                  </div>
                </Col>

              </Row>


            </ModalBody>
          </Modal>
        </div>
      </div>


      {duplicateerro ? (
        <SweetAlert
          title="Product  Already exists "
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          danger
          onConfirm={() => {
            setduplicateerro(false)
          }}
        ></SweetAlert>
      ) : null}
      {duplicateerro1 ? (
        <SweetAlert
          title="SKU ID Already exists "
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          danger
          onConfirm={() => {
            setduplicateerro1(false)
          }}
        ></SweetAlert>
      ) : null}

      {coutrysuccess ? (
        <SweetAlert
          title="Product Added Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setcoutrysuccess(false)
          }}
        ></SweetAlert>
      ) : null}

      {countryinfo ? (
        <SweetAlert
          title="Product Updated Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setcountryinfo(false)
          }}
        ></SweetAlert>
      ) : null}

      {countryerror ? (
        <SweetAlert
          title="Product Deleted Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setcountryerror(false)
          }}
        ></SweetAlert>
      ) : null}

      {noRecords ? (
        <SweetAlert
          title="No Records Found for InActive"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setnoRecords(false)
          }}
        ></SweetAlert>
      ) : null}

        {deletedconfirm ? (
                    <SweetAlert
                      title="Are You Sure?"
                      style={{
                        position: 'absolute',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                      confirmBtnBsStyle="success"
                      showConfirm={true}
                      cancelBtnBsStyle="danger"
                      cancelBtnText="Cancel"
                      confirmBtnText="Yes,delete it!"
                      showCancel={true}
                      warning
                      onConfirm={() => {
                        // DeleteBuyer();
                        Countrydelete()
                        setdeletedconfirm(false);
                      }}
                      onCancel={() => {
                        setdeletedconfirm(false);
                        // setdeleted(false);
                      }}
                    >
                      <p style={{ fontSize: '20px' }}>You Won't able to revert this!</p>
                    </SweetAlert>
                  ) : null}
      {/* <Brandmaster 
   ShowModalProps={ShowSeriesModal}
   ShowModaltrue={RandomCallSeries}
   isEditProps={brandid.length!=0}
   EditIdProps={brandid}
   ComponentPropsSeries={true}
   Callback={CallbackfromMasterSeries}
  //  Callback={returnFromMaster}
/> */}

      {/* <UomMaster 
   ShowModalProps={ShowUOMmaster}
   ShowModal={RandomCallbackUom}
   EditUomType={UomClickType}
   EditIdPropsPri={priuomid}
   EditIdPropsSec={secuomid}
   isEditProps={(priuomid.length!=0||secuomid.length!=0)}
   ComponentProps={true}
   Callback={CallbackfromMaster}

/> */}

      {/* <CategoryMaster 
   ShowModalProps={CatShowModal}
   ShowModal={RandomCallBackCat}
   isEditProps={categrid.length!=0}
   EditIdProps={categrid}
   ComponentProps={true}
    Callback={CallbackfromMasterCat}
  //  Callback={returnFromMaster}
/> */}

      <Backdrop open={dialogbox} className={classes.backdrop}>
        <Spinner name="ball-spin-fade-loader" color="#fafafa" />
      </Backdrop>

      <Dialog
        onClose={Closepopup}
        aria-labelledby="simple-dialog-title"
        open={open}
      >
        <img
          src={Poupuimage}
          style={{ width: "400px", height: "auto", objectFit: "contain" }}
        />
      </Dialog>

      {/* /* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      // fullScreen
      >
        {/* <div className="loader"></div> */}

        <LinearProgress />
      </Dialog>
    </React.Fragment>
  )
}
DatatableTables.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default DatatableTables
